import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locals/en/common.json';
import ar from './locals/ar/common.json';

i18n.use(initReactI18next).init({
  lng: localStorage.getItem('lang') || 'en',
  resources: {
    en: {
      translation: en,
    },
    ar: {
      translation: ar,
    },
  },
  supportedLngs: ['en', 'ar'],
  fallbackLng: ['en', 'ar'],
});

export default i18n;
